(function () {
    'use strict';

    var classList = {
        add: function (element, className) {
            if (false === classList.has(element, className)) {
                element.className += ' ' + className;
            }
        },
        remove: function (element, className) {
            element.className = element.className.replace(new RegExp('(^|\\s)' + className + '(?=\\s|$)', 'g'), '');
        },
        has: function (element, className) {
            return null !== element.className.match(new RegExp('(^|\\s)' + className + '(?=\\s|$)', 'g'));
        },
        toggle: function (element, className) {
            classList[
                classList.has(element, className) ?
                    'remove' :
                    'add'
                ](element, className);
        },
        moveTo: function (oldElement, newElement, className) {
            classList.remove(oldElement, className);
            classList.add(newElement, className);
            return newElement;
        }
    };

    module.exports = classList;

})();